
import {
  IonContent,
  IonPage,
  IonList,
  IonListHeader,
  IonLabel,
  IonInput,
  IonItem,
  IonButton,
  IonCheckbox,
} from "@ionic/vue";
import router from "../router";
import api from "../network";
import { defineComponent } from "vue";
import { bus } from "../main";

export default defineComponent({
  name: "Login",
  components: {
    IonContent,
    IonPage,
    IonList,
    IonListHeader,
    IonLabel,
    IonInput,
    IonItem,
    IonButton,
    IonCheckbox,
  },
  data() {
    return {
      usr: "" as string,
      pwd: "" as string,
      state: "" as string,
      termsChecked: false,
    };
  },
  methods: {
    login(): void {
      if (this.termsChecked !== true) {
        bus.emit("toastMessage", {
          message: "Please Read and Agree to the Terms and Condtions",
          isError: true,
        });
        return;
      }
      this.state = "Logging In...";
      api
        .login(this.usr, this.pwd)
        .then(() => {
          const msg = "Logged in";
          this.state = msg;
          bus.emit("toastMessage", { message: msg });

          router.push("/chats");
          location.reload();
        })
        .catch((err) => {
          const errmsg = "" + err;
          this.state = errmsg;
          bus.emit("toastMessage", { message: errmsg, isError: true });
        });
    },
    newUser() {
      if (this.termsChecked !== true) {
        bus.emit("toastMessage", {
          message: "Please Read and Agree to the Terms and Condtions",
          isError: true,
        });
        return;
      }
      router.push("/register");
    },
    tAndCs() {
      router.push("/terms");
    },
    forgotPassword() {
      router.push("/resetpassword");
    },
  },
});
